// Shared between API and frontend types

// Detect

export enum ApiModel {
	SAPLING,
	SMODIN,
}

export interface DetectResponse {
	score: number; //0-1
	sentence_scores: {
		score: number; //0-1
		startIndex: number;
		endIndex: number;
		sequence: string;
	}[];
	text: string;
	api: ApiModel;
}

// Read File

export interface ReadFileResponse {
	text: string;
}

// Plagiarism

export interface PlagiarismResponse {
	text: string;
	indexes: { startIndex: number; endIndex: number }[];
	score: number; // 0-1
	sources: PlagiarismSource[];
	sourceCounts?: number;
	textWordCounts?: number;
	totalPlagiarismWords?: number;
	identicalWordCounts?: number;
	similarWordCounts?: number;
}

export interface PlagiarismSource {
	plagiarismFound: PlagiarismFoundResult[];
	score: number; // 0-1
	title: string;
	url: string;
	canAccess?: boolean;
	plagiarismWords?: number;
	identicalWordCounts?: number;
	similarWordCounts?: number;
	similarWords?: PlagiarismSimilarWord[];
	totalNumberOfWords?: number;
	author?: string;
	description?: string;
	source?: string;
	citation?: boolean;
	is_excluded?: boolean;
	publishedDate?: number; //timestamp
}

interface PlagiarismSimilarWord {
	word: string;
	index: number;
}

interface PlagiarismFoundResult {
	sequence: string;
	startIndex?: number;
	endIndex?: number;
}

// Language

export const SUPPORTED_LANGUAGES = [
	"en",
	"de",
	"auto",
	"af",
	"sq",
	"am",
	"ar",
	"hy",
	"az",
	"eu",
	"be",
	"bn",
	"bs",
	"bg",
	"ca",
	"ceb",
	"ny",
	"zh-cn",
	"zh-tw",
	"co",
	"hr",
	"cs",
	"da",
	"nl",
	"eo",
	"et",
	"tl",
	"fi",
	"fr",
	"fy",
	"gl",
	"ka",
	"el",
	"gu",
	"ht",
	"ha",
	"haw",
	"iw",
	"hi",
	"hmn",
	"hu",
	"is",
	"ig",
	"id",
	"ga",
	"it",
	"ja",
	"jw",
	"kn",
	"kk",
	"km",
	"ko",
	"ku",
	"ky",
	"lo",
	"la",
	"lv",
	"lt",
	"lb",
	"mk",
	"mg",
	"ms",
	"ml",
	"mt",
	"mi",
	"mr",
	"mn",
	"my",
	"ne",
	"no",
	"ps",
	"fa",
	"pl",
	"pt",
	"ro",
	"ru",
	"sm",
	"gd",
	"sr",
	"st",
	"sn",
	"sd",
	"si",
	"sk",
	"sl",
	"so",
	"es",
	"su",
	"sw",
	"sv",
	"tg",
	"ta",
	"te",
	"th",
	"tr",
	"uk",
	"ur",
	"uz",
	"vi",
	"cy",
	"xh",
	"yi",
	"yo",
	"zu",
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const ISO639_1_LANGUAGES = [
	"ar",
	"am",
	"bg",
	"bn",
	"ca",
	"cs",
	"da",
	"de",
	"el",
	"en",
	"es",
	"es_419",
	"et",
	"fa",
	"fi",
	"fil",
	"fr",
	"gu",
	"he",
	"hi",
	"hr",
	"hu",
	"id",
	"it",
	"ja",
	"kn",
	"ko",
	"lt",
	"lv",
	"ml",
	"mr",
	"ms",
	"nl",
	"no",
	"pl",
	"pt_br",
	"pt_pt",
	"ro",
	"ru",
	"sk",
	"sl",
	"sr",
	"sv",
	"sw",
	"ta",
	"te",
	"th",
	"tr",
	"uk",
	"vi",
	"zh_cn",
	"zh_tw",
] as const;

export type ISO639_1_Language = (typeof ISO639_1_LANGUAGES)[number];
